var _defs, _path, _rect, _rect2, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSoporte33(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2196f3;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.24,3.2H9.76A6.56,6.56,0,0,0,3.2,9.76V40.24A6.56,6.56,0,0,0,9.76,46.8H40.24a6.56,6.56,0,0,0,6.56-6.56V9.76A6.56,6.56,0,0,0,40.24,3.2Zm4.56,37a4.57,4.57,0,0,1-4.56,4.56H9.76A4.57,4.57,0,0,1,5.2,40.24V9.76A4.57,4.57,0,0,1,9.76,5.2H40.24A4.57,4.57,0,0,1,44.8,9.76Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 33.66,
    y: 16.9,
    width: 2.14,
    height: 17
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 28.8,
    y: 16.9,
    width: 1.98,
    height: 17
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.78,33.9H26v-17H13.78Zm2-15H24v13H15.78Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSoporte33);
export default __webpack_public_path__ + "static/media/IconSoporte-33.6c7823047e3e489a868c974d3df14e4c.svg";
export { ForwardRef as ReactComponent };